"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRICE_TO_QUOTE_PRECISION = exports.AMM_TO_QUOTE_PRECISION_RATIO = exports.AMM_RESERVE_PRECISION = exports.PEG_PRECISION = exports.FUNDING_PAYMENT_PRECISION = exports.MARK_PRICE_PRECISION = exports.QUOTE_PRECISION = exports.PARTIAL_LIQUIDATION_RATIO = exports.FULL_LIQUIDATION_RATIO = exports.MAX_LEVERAGE = exports.BN_MAX = exports.TEN_THOUSAND = exports.ONE = exports.ZERO = void 0;
const bn_js_1 = __importDefault(require("bn.js"));
exports.ZERO = new bn_js_1.default(0);
exports.ONE = new bn_js_1.default(1);
exports.TEN_THOUSAND = new bn_js_1.default(10000);
exports.BN_MAX = new bn_js_1.default(Number.MAX_SAFE_INTEGER);
exports.MAX_LEVERAGE = new bn_js_1.default(5);
exports.FULL_LIQUIDATION_RATIO = new bn_js_1.default(500);
exports.PARTIAL_LIQUIDATION_RATIO = new bn_js_1.default(625);
exports.QUOTE_PRECISION = new bn_js_1.default(Math.pow(10, 6));
exports.MARK_PRICE_PRECISION = new bn_js_1.default(Math.pow(10, 10));
exports.FUNDING_PAYMENT_PRECISION = new bn_js_1.default(10000);
exports.PEG_PRECISION = new bn_js_1.default(1000);
exports.AMM_RESERVE_PRECISION = new bn_js_1.default(Math.pow(10, 13));
exports.AMM_TO_QUOTE_PRECISION_RATIO = exports.AMM_RESERVE_PRECISION.div(exports.QUOTE_PRECISION); // 10^7
exports.PRICE_TO_QUOTE_PRECISION = exports.MARK_PRICE_PRECISION.div(exports.QUOTE_PRECISION);
